import { render, staticRenderFns } from "./HistoricalDataLine.vue?vue&type=template&id=d23f2e00&"
import script from "./HistoricalDataLine.vue?vue&type=script&lang=js&"
export * from "./HistoricalDataLine.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalDataLine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports